module.exports = __webpack_public_path__ + "static/media/productDetail.397500bc.PNG";